import { Baseurl } from "./url";
import { errorMessage } from "./apiError";
import { getToken } from "./authentication";

// Admin-only calls (the backend answers 403 to anyone else).

const authHeaders = () => ({ 'Authorization': getToken() });
const FAILED = "Sorry, that didn't work. Please try again.";

// Requested clocks, newest first. status: 'pending' | 'approved' | 'rejected' | '' for all.
// Returns { ok: true, clocks } or { ok: false, message }.
export async function getClockRequests(status = '') {
    const query = status ? `?status=${encodeURIComponent(status)}` : '';
    const response = await fetch(`${Baseurl}/admin/clock-locations${query}`, { headers: authHeaders() });
    if (response.ok) {
        const clocks = await response.json();
        return { ok: true, clocks: Array.isArray(clocks) ? clocks : [] };
    }
    return { ok: false, message: await errorMessage(response, FAILED) };
}

// Approve (puts the clock on the map) or reject a pending request. note is optional
// and is shown to the person who asked. status: 'approved' | 'rejected'.
export async function reviewClockRequest(id, status, note = '') {
    const response = await fetch(`${Baseurl}/admin/clock-locations/${id}/review`, {
        method: 'POST',
        headers: { ...authHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: status, note: note })
    });
    if (response.ok) {
        return { ok: true, clock: await response.json() };
    }
    return { ok: false, status: response.status, message: await errorMessage(response, FAILED) };
}

export async function getUsers() {
    const response = await fetch(`${Baseurl}/admin/users`, { headers: authHeaders() });
    if (response.ok) {
        const users = await response.json();
        return { ok: true, users: Array.isArray(users) ? users : [] };
    }
    return { ok: false, message: await errorMessage(response, FAILED) };
}

// role: 'user' | 'admin'
export async function setUserRole(id, role) {
    const response = await fetch(`${Baseurl}/admin/users/${id}/role`, {
        method: 'POST',
        headers: { ...authHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ role: role })
    });
    if (response.ok) {
        return { ok: true, user: await response.json() };
    }
    return { ok: false, message: await errorMessage(response, FAILED) };
}

export const EXPORTS = {
    reports: { path: '/admin/clock-reports/export', filename: 'clock-reports.csv' },
    clocks: { path: '/admin/clock-locations/export', filename: 'clock-locations.csv' },
};


export async function downloadExport(kind) {
    const target = EXPORTS[kind];
    const response = await fetch(`${Baseurl}${target.path}`, { headers: authHeaders() });
    if (!response.ok) {
        return { ok: false, message: await errorMessage(response, FAILED) };
    }
    const url = URL.createObjectURL(await response.blob());
    const link = document.createElement('a');
    link.href = url;
    link.download = target.filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    return { ok: true };
}
